import {
  getApplovinLanding,
  waitForAxwrtCookie,
} from '@openeducation/pp-js-utils';
import { PPApiService } from '@openeducation/pp-rn-services';

import { useEnvironmentContext } from '../../../environment/environment.provider';
import { useGoogleTagManager } from '../../../hooks';

interface TrackBeginCheckoutParams {
  sfdcToken: string;
}

// Sends begin_checkout to the dataLayer. On every checkout, with or without
// aleid and alart, it also calls pp-api-gateway, which sends page_view and
// begin_checkout to the AppLovin Conversion API. pp-api-gateway makes the
// dedupe ids of the two events.
export const useTrackBeginCheckout = () => {
  const { environment } = useEnvironmentContext();
  const { pushEvent } = useGoogleTagManager();

  const trackBeginCheckout = async ({
    sfdcToken,
  }: TrackBeginCheckoutParams) => {
    pushEvent({ event: 'begin_checkout' });

    const landing = getApplovinLanding(sfdcToken);
    // No page URL: there is nothing to send.
    if (!landing) {
      return;
    }

    try {
      const axwrt = await waitForAxwrtCookie();
      await PPApiService.trackBeginCheckout(environment, {
        sfdcToken,
        ...landing,
        ...(axwrt ? { axwrt } : {}),
      });
    } catch {
      // A tracking error must not stop the checkout.
    }
  };

  return { trackBeginCheckout };
};
